(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter"]) return;
  try {
    
  KlaviyoSubscribe.attachToForms('#subscribe-form-page', {
    hide_form_on_success: true,
    success_message: "Please look out for the confirmation email.",
    extra_properties: {
      $source: '$embed',
      $method_type: "Klaviyo Form",
      $method_id: 'embed',
      $consent_version: 'Embed default text'
    },
    success: function ($form) {
      setTimeout(function() { 
          $(".success_message, .footer-newsletter-pop-up").hide();
          Cookies.set("cookies", "1");
          $("body").removeClass("newsletter-open");
      }, 5000);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
